function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { Controls, validators } from 'shared/helper/form';
import { T } from 'shared/helper/translate';
import { paymentMethodSupportsFapiao } from 'researcher/domain/transaction/payment-method';
import { getFapiaoAvailable } from '../reducer';
var Radio = Controls.Radio;
var notEmpty = validators.notEmpty;
var FapiaoRequirementForm = function FapiaoRequirementForm(_ref) {
  var fapiaoSelectionDisabled = _ref.fapiaoSelectionDisabled,
    total = _ref.total;
  var methods = useFormContext();
  var fapiaoAvailable = useSelector(getFapiaoAvailable);
  var visible = total > 0 && fapiaoAvailable;
  var _methods$watch = methods.watch(['fapiaoRequirementConfirmed', 'paymentMethodId']),
    _methods$watch2 = _slicedToArray(_methods$watch, 2),
    fapiaoRequirementConfirmed = _methods$watch2[0],
    paymentMethodId = _methods$watch2[1];
  useEffect(function () {
    var requireFapiao = fapiaoRequirementConfirmed === 'yes';
    methods.setValue('requireFapiao', requireFapiao);
    if (!paymentMethodSupportsFapiao(paymentMethodId)) {
      methods.resetField('paymentMethodId');
    }
    if (!requireFapiao) {
      methods.resetField('fapiao');
    }
  }, [fapiaoRequirementConfirmed]);
  if (!visible) {
    return null;
  }
  if (fapiaoSelectionDisabled) {
    return /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-md-12"
    }, /*#__PURE__*/React.createElement("div", {
      className: "alert alert-info mt-0 mb-3"
    }, /*#__PURE__*/React.createElement(T, {
      source: "fapiao-multiple-po-warning"
    }))));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pb-3"
  }, /*#__PURE__*/React.createElement(Radio, {
    label: "Do you require fapiao?",
    name: "fapiaoRequirementConfirmed",
    options: [{
      value: 'yes',
      label: /*#__PURE__*/React.createElement(T, {
        source: "Yes"
      })
    }, {
      value: 'no',
      label: /*#__PURE__*/React.createElement(T, {
        source: "No"
      })
    }],
    styles: {
      controls: 'fapiao-requirement-form mt-0 mb-2 pb-1',
      formCheck: 'form-check-inline me-0 ms-3',
      label: 'col font-weight-bold mb-0 ps-0',
      wrapper: 'mb-3 row alert alert-info m-0 pb-0'
    },
    validators: {
      notEmpty: notEmpty
    },
    messages: {
      notEmpty: 'You must select an option'
    }
  }))));
};
export default FapiaoRequirementForm;